export const replaceAll = (
  value: string,
  search: string,
  replaceValue: string
): string => {
  const replaced = value.split(search).join(replaceValue)

  return replaced
}
